// @ts-nocheck

import Warning from './warning';


export default Warning;
